import { stripeCheckoutUrl } from '#app/utils/constants.ts'
import { cn } from '#app/utils/tailwind-merge.ts'

export function ReserveSeat({ className }: { className?: string }) {
	return (
		<a
			href={stripeCheckoutUrl}
			className={cn(
				'inline-flex items-center justify-center bg-terracotta px-5 py-3 text-sm font-medium tracking-wide text-cream transition-transform duration-150 hover:brightness-110 active:translate-y-px active:scale-[0.98]',
				className,
			)}
		>
			Reserve a seat
		</a>
	)
}
